import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { withTheme } from '@material-ui/core/styles';
import CRMComponent from './CRMComponent';
import { Page } from 'ecrion-components';

var CRMPage = function CRMPage(_ref) {
  var theme = _ref.theme,
      history = _ref.history,
      onClose = _ref.onClose,
      location = _ref.location,
      logPath = _ref.logPath,
      id = _ref.id,
      rest = _objectWithoutProperties(_ref, ["theme", "history", "onClose", "location", "logPath", "id"]);

  var icon = null;

  if (history || onClose) {
    icon = {
      type: 'close',
      onClick: undefined
    };

    if (history) {
      icon.onClick = function () {
        return history && history.return && history.return('/settings');
      };
    } else if (onClose) {
      icon.onClick = onClose;
    }
  }

  var showLog = location.pathname.startsWith(logPath);
  return React.createElement(React.Fragment, null, React.createElement(Page.ToolBar, {
    icon: icon,
    leftChildren: showLog ? 'Synchronization Log' : 'Configure Integration',
    color: "navbar"
  }), React.createElement(Page.Common, null, React.createElement(CRMComponent, Object.assign({
    id: id
  }, rest, {
    showLog: showLog
  }))));
};

CRMPage.defaultProps = {
  onClose: null,
  id: 'Engage'
};
export default withTheme(CRMPage);